<template>
  <li class="project-node"
      v-show="node.name && !node.show && movedHide"
      :class="{ 'last-children': node.level === 1 && node.id === lastId }"
      draggable="false">
    <div class="project-item projects-dropzone"
         :draggable="permissionCheck > 1 ? true : false"
         @dragstart="dragStart(node, $event, drugConfig)"
         @mousedown="setDelta"
         @dblclick="goToProjectItem(node)"
         @mouseenter="showControls = true"
         @mouseleave="showControls = false"
         :class="{'no-right-margin': node.levelLength > 0, 'item-blocked': node.permission_level < 2 || isMotherToDraggedEl(node)}"
         :ref="'projects' + node.id"
         :data-project="node.id ? node.id : null"
         v-if="!isMother && !node.dopNode">
      <slot name="beforeNode"></slot>
      <slot name="afterNode"></slot>
      <div class="project-top">
        <p class="project-name">
<!--          <span v-if="node.name.length < 17" >{{node.name}}</span>-->
<!--          <span v-else>{{node.name.slice(0, 16)}}...</span>-->
          <trim-item :string="node.name"
                     :width="nameWidth"></trim-item>
        </p>
        <transition name="fade">
          <div v-show="showControls"
               class="controls-cont">
            <button type="button"
                    @click="goToSettings(node.id)">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.91254 1.21996L8.19254 0.489966C8.13254 0.429966 8.06255 0.399963 7.98255 0.399963C7.90255 0.399963 7.82254 0.429966 7.77254 0.489966L3.58255 4.73997C3.55255 4.76997 3.53254 4.79997 3.51254 4.83997L3.04254 6.02997C3.00254 6.13997 3.02254 6.26996 3.11254 6.34996C3.17254 6.40996 3.24254 6.43997 3.32254 6.43997C3.36254 6.43997 3.39255 6.42996 3.43255 6.41996L4.61254 5.94996C4.65254 5.92996 4.68254 5.90997 4.71254 5.87997L8.90254 1.62997C9.03254 1.51997 9.03254 1.32996 8.91254 1.21996ZM4.34254 5.41996L3.86254 5.60996L4.05254 5.11996L7.98255 1.12997L8.28255 1.42997L4.34254 5.41996ZM7.40254 5.05996V9.09996C7.40254 9.31996 7.20255 9.49996 6.98255 9.49996H1.30254C1.08254 9.49996 0.902542 9.31996 0.902542 9.09996V1.47997C0.902542 1.25997 1.08254 1.09996 1.30254 1.09996H5.46254C5.68254 1.09996 5.86254 1.27996 5.86254 1.49996C5.86254 1.71996 5.68254 1.89996 5.46254 1.89996H1.70254V8.69996H6.60254V5.05996C6.60254 4.83996 6.78254 4.65996 7.00254 4.65996C7.22254 4.65996 7.40254 4.83996 7.40254 5.05996Z" fill="white"/>
              </svg>

            </button>
            <button type="button"
                    v-if="node.permission_level > 2"
                    @click="delProjectItem(node.name, node.id)"
                    class="del-icon">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.24256 3.33997L7.93256 9.11996C7.92256 9.32996 7.74256 9.49996 7.53256 9.49996H2.46256C2.25256 9.49996 2.07256 9.32996 2.06256 9.11996L1.75256 3.33997C1.74256 3.11997 1.91257 2.92996 2.13257 2.91996C2.35257 2.90996 2.54256 3.07996 2.55256 3.29996L2.84256 8.69996H7.15256L7.44256 3.29996C7.45256 3.07996 7.64256 2.90996 7.86256 2.91996C8.08256 2.92996 8.25256 3.11997 8.24256 3.33997ZM9.30256 1.99996C9.30256 2.21996 9.12256 2.39996 8.90256 2.39996H1.10256C0.88256 2.39996 0.70256 2.21996 0.70256 1.99996C0.70256 1.77996 0.88256 1.59996 1.10256 1.59996H3.30256V0.699963C3.30256 0.509963 3.43256 0.399963 3.62256 0.399963H6.38256C6.57256 0.399963 6.70256 0.509963 6.70256 0.699963V1.59996H8.90256C9.12256 1.59996 9.30256 1.77996 9.30256 1.99996ZM4.00256 1.59996H6.00256V1.09996H4.00256V1.59996ZM4.17256 8.09996C4.37256 8.09996 4.52256 7.90996 4.52256 7.71996L4.42256 3.39996C4.42256 3.20996 4.26256 3.04996 4.06256 3.04996C3.87256 3.04996 3.71256 3.20996 3.72256 3.40996L3.82256 7.73997C3.82256 7.92997 3.98256 8.09996 4.17256 8.09996ZM5.82256 8.09996C6.01256 8.09996 6.17256 7.93996 6.17256 7.74996L6.27256 3.42997C6.27256 3.23997 6.12256 3.06996 5.93256 3.06996C5.73257 3.06996 5.58256 3.21996 5.57256 3.40996L5.47256 7.72997C5.46256 7.92997 5.62256 8.09996 5.82256 8.09996C5.81256 8.09996 5.81256 8.09996 5.82256 8.09996Z" fill="white"/>
              </svg>

            </button>
          </div>
        </transition>
      </div>
      <div class="roles-cont">
        <p class="user-name">
          {{$t('projects.project.roles')}}
        </p>
        <button type="button"
                @click="goToRolesItem(node)"
                class="project-roles">
          {{returnRolesLength(node)}}
        </button>
      </div>
      <div class="roles-cont">
        <p class="user-name">
          {{$t('projects.project.thingItem')}}:
        </p>
        <button type="button"
                @click="goToItems(node)"
                class="project-roles">
          {{returnThingsLength(node)}}
        </button>
      </div>

      <button type="button"
              v-if="node.permission_level > 1"
              @click="addSection(node.id)"
              v-show="showControls"
              class="add-btn add-project add-btn-bottom hint-cont">
        <plus-small-icon class="add-project"></plus-small-icon>
        <p class="btn-hint  btn-hint_bottom">
          {{$t('projects.addBottom')}}
        </p>
      </button>
    </div>

    <div v-if="node.dopNode"
         :data-project="node.id"
         class="project-item project-item-dop projects-dropzone">
    </div>

    <ul class="inner-list"
        draggable="false"
        :class="{'first_level': isMother, 'hide-line': node.items.length > 0 && isMother, 'inner-list_vertical': node.levelLength > 0 && !isMother}"
        v-if="node.items && node.items.length && !node.dopNode">
<!--      :style="{height: `calc(100% - 6px - ${returnHeightLine(node)}px)`}"-->
      <li class="line-item"
          draggable="false"
          :style="{height: `calc(100% - ${returnHeightLine(node)}px)`}"
          v-if="node.levelLength > 0">
      </li>
      <node class="project-show"
            :class="{ 'hide-line-dop': i === 1 || i === node.items.length - 2 || i === 0 || i ===  node.items.length - 1}"
            draggable="false"
            :level="i"
            :lastId="lastId"
            :mother-project="motherProject"
            v-for="(project,i) in node.items"
            @addNodeOnDragEmit="$emit('addNodeOnDragEmit', $event)"
            :dragFlag="dragFlag"
            :mother-node="node"
            @lastChildWidth="$emit('lastChildWidth', randString())"
            :node="project">

        <!--невидимые зоны-->
        <div class="dop-node before-node projects-dropzone"
             v-if="project.sort_attribute || project.sort_attribute === null"
             :class="{ 'before-node-first-level': project.level === 1 }"
             :data-index="project.prevElem"
             :data-id="project.id"
             :data-parent-id="project.parentId"
             slot="beforeNode"
        ></div>
        <div class="dop-node after-node projects-dropzone"
             v-if="project.sort_attribute || project.sort_attribute === null"
             :class="{ 'after-node-first-level': project.level === 1 }"
             :data-index="project.nextElem"
             :data-id="project.id"
             :data-parent-id="project.parentId"
             slot="afterNode"
        ></div>
      </node>
    </ul>
  </li>
</template>

<script>
  import trimItem from '../../../trimITem'
  import editIcon from '../../../Svg/projects/editProject'
  import plusIcon from '../../../Svg/plusIcon'
  import plusSmallIcon from '../../../Svg/plusSmallIcon'
  import delIcon from '../../../Svg/cart_control/delIcon'
  import {showOverlay} from "../../../../mixins/utils/showOverlay";
  import {mapGetters,mapMutations} from 'vuex'
  import {dragNdrapProjects} from "../../../../mixins/dragNdrop/dragNdropProjects";
  import {projectItem} from "../../../../mixins/projects/projectItem";
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {singleProject} from "../../../../mixins/projects/singleProject";

  export default {
    name: 'node',
    props: {
      node: Object,
      motherProject: Object,
      level: Number,
      lastId: Number,
      motherNode: Object,
      dragFlag: String
    },
    mixins: [showOverlay, projectItem, dragNdrapProjects, tokenAndRoute, singleProject],
    components: {
      trimItem,
      editIcon,
      plusIcon,
      plusSmallIcon,
      delIcon
    },
    data() {
      return {
        showControls: false,
        movedHide: true
      }
    },
    computed: {
      ...mapGetters({
        firstLevel: 'projects/projectsTreeFirstLevel',
        projectsTree: 'projects/projectsTree',
      }),

      nameWidth() {
        return 1
      },
      isMother() {
        return (this.node.name === this.motherProject.name &&
                this.node.id === this.motherProject.id &&
                this.node.crated_at === this.motherProject.created_at)
      },
      lastChildWidth() {
        return this.randString()
      }
    },
    watch: {
      dragFlag() {
        this.movedHide = true
      },
      lastId() {
        this.$emit('lastChildWidth', this.randString())
      }
    },
    methods: {
      ...mapMutations({
        showDelPopup: 'projects/SET_SHOW_DEL_POPUP',
        setDelName: 'projects/SET_DEL_ITEM_NAME',
        setDelId: 'projects/SET_DEL_ITEM_ID',
        showAddSection: 'projects/SET_SHOW_ADD_SECTION',
        setAddId: 'projects/SET_ADD_SECTION_ID_CHILD',
        setActiveTab: 'projects/SET_ACTIVE_HEADER_TAB'
      }),
      isNoMove() {
        // moved_class-opacity
        let listClass = document.getElementsByClassName('moved_class-opacity')
        this.movedHide = !listClass;
      },
      // считывание данных с невидимых зон
      addNodeOnDrag(elem) {
        let allActiveDopElem = document.getElementsByClassName('colorTest')
        if (allActiveDopElem.length > 0) {
          allActiveDopElem.forEach((item) => {
            item.classList.remove('colorTest')
          })
        }
        elem.classList.add('colorTest')
        let count = elem.getAttribute('data-index')
        let id = elem.getAttribute('data-id')
        let parentId = elem.getAttribute('data-parent-id')

        this.$emit('addNodeOnDragEmit', {count: count, id: id, parentId: parentId})
      },
      goToRolesItem(node) {
        this.setActiveTab('projectRoles');
        this.$router.push(`/project-edit/${this.$route.params.id}/project-item/${node.id}`)
      },
      goToItems(node) {
        this.setActiveTab('projectThings');
        this.$router.push(`/project-edit/${this.$route.params.id}/project-item/${node.id}`)
      },
      isMotherToDraggedEl(node) {
        return node.items.find(item => item.id === this.draggedEl.id)
      },
      goToSettings(id) {
        this.setActiveTab('projectSettings');
        this.$router.push(`/project-edit/${this.$route.params.id}/project-item/${id}`)
      },
      addSection(id) {
        this.setAddId(id);
        this.showOverlay(true);
        this.showAddSection(true);
      },
      delProjectItem(name,id) {
        this.setDelName(name);
        this.showDelPopup(true);
        this.setDelId(id);
        this.showOverlay(true)
      },
      returnHeightLine(nodeObj) {
        const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        const isMacOS = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);

        let node = JSON.parse(JSON.stringify(nodeObj))
        // let node = { ...nodeObj }
        let childArr = (items) => {
          items.forEach((item, index) => {
            if (item.show) {
              items.splice(index, 1)
            }
            if (item.items && item.items.length > 0) {
              childArr(item.items)
            }
          })
        }
        if (node.items && node.items.length > 0) {
          childArr(node.items)
        }
        // так как у последнего может быть несколько предков и линия идет по пизде
        // нужно понять, сколько предков у последнего элемента через вот такую ебанину
        // node.items[node.items.length - 1].items.length
        // после чего сделать линию меньше

        // где n - число предков,
        // h - высота элемента,
        // m - margin = 20px
        let h = 94;
        let m = 20;
        //какая то погрешность в 5px. хуй его знает, откуда она :D
        let delta = 5;

        if (isFirefox) {
          h = 94
          delta = 5.5
        }

        if (node.items.length && node.items[node.items.length - 1].items.length) {
          let nn = node.items.length
          let n = node.items[node.items.length - 1].items.length

          if (n === 1 && nn === 1 && node.level !== 1 && node.items[node.items.length - 1].items[node.items[node.items.length - 1].items.length - 1].length < 1) {
            //один элемент с горизонтальной линией
            //высота 1 элемента + его маржин + половина высоты родителя
            if (isFirefox) {
              return h + m + h/2 + delta
            } else if (isMacOS) {
              return h + m + h/2 + delta + 2
            } else {
              return h + m + h/2 + delta
            }

          } else
          {
            let nChild = 0
            let deltaLevel = 0
            const nChildFunc = (child) => {
              if (child.items.length > 0) {
                child.items.forEach((item, index) => {
                  if (item.show) {
                    nChild -= 1
                  }
                  nChild += 1
                  if (item.items.length > 0) {
                    nChildFunc(item)
                  }
                })
              }
            }
            nChildFunc(node.items[node.items.length - 1])
            //больше одного столбеца
            //n высот дочек + n маржинов дочек + половина высоты родителя

            if (isFirefox) {
              //сейчас повтор в условии, но на случай если что то еще поедит криво
              return (nChild * h) + (nChild * m) + h/2 + delta
            } else if (isMacOS) {
              return (nChild * h) + (nChild * m) + h/2 + delta
            } else {
              return (nChild * h) + (nChild * m) + h/2 + delta
            }

          }
        } else {
          if (isFirefox) {
            return  h/2 + delta/2 + 2.7
          } else if (isMacOS){
            return h/2 + delta
          } else {
            return h/2 + delta
          }
        }
      },
      randString() {
        let text = "";
        let possible = "abcdefghijklmnopqrstuvwxyz";
        for( let i=0; i < 5; i++ )
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
      },
      goToProjectItem(node) {
        this.$router.push(`/project/${this.routeId}/project-item/${node.id}`)
      }
    },
    mounted() {
      this.$emit('lastChildWidth', this.randString())
      if (this.node.level === 1 && this.node.id === this.lastId) {
        this.$emit('lastChildWidth', this.randString())
      }
    }
  }
</script>

<style lang="scss" scoped>
  $line: #6194AF;

  .hide-line {
    > .project-node {
      &:first-child, &:last-child {
        > .project-item {
          &:before {
            display: none;
          }
        }
      }

      &:last-child, &:nth-last-child(2) {
        > .project-item {
          &:before {
            left: calc(50% - 0.5px);
          }
        }
      }
    }
  }

  .project-item {
    background: white;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 1px 0 #F5F8FA;
    border: 1px solid #F5F8FA;
    width: 180px;
    min-height: 94px;
    max-height: 94px;
    height: 94px;
    position: relative;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    user-select: none;

    &::before {
      content: '';
      position: absolute;
      width: 1px;
      height: 26px;
      background: $line;
      left: 50%;
      bottom: calc(100% + 1px);
    }

    &.projects-drop {
      opacity: .5;
    }
  }

  .moved_class-opacity {
    //opacity: .6;
    display: none;
  }

  .no-right-margin {
    margin-right: 0;
  }

  .project-show:first-of-type .project-item, .project-show:last-of-type .project-item {
    &::before {
      height: 20px;
    }
  }

  .user-name {
    font-family: $mm;
    font-size: 12px;
    margin-bottom: 2px;
  }

  .inner-list {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }


  .project-name {
    font-family: $msb;
    font-size: 12px;
    letter-spacing: .25px;

    width: 100%;
  }

  .project-name_trimmed {
    width: calc(100% - 66px);
  }

  .roles-cont {
    display: flex;
    align-items: center;
  }

  .project-roles {
    color: $lightBlue;
    font-family: $mm;
    font-size: 12px;
    margin-left: 10px;
  }

  .inner-list_vertical {
    flex-direction: column;
    /*transform: translateX(30px);*/
    margin-left: 30px;
    position: relative;
    //margin-right: -30px;
  }

  /*.project-show {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      width: 1px;
      background: $line;
      height: 100%;
      left: 0;
      top: 0;
    }
  } */

  /*.first_level {*/
    /*& > .project-show {*/
      /*&::before {*/
        /*display: none;*/
      /*}*/
    /*}*/
  /*}*/

  /*.first_level > .project-node > .project-item {*/

    /*&:first-of-type {*/
      /*margin-left: 20px;*/
    /*}*/

    /*&:last-of-type {*/
      /*margin-right: 20px;*/
    /*}*/
  /*}*/

  .line-item {
    position: absolute;
    width: 1px;
    background: $line;
    left: 0;
    top: 0;

    &::before {
      content: '';
      position: absolute;
      width: 14px;
      height: 14px;
      left: 0;
      bottom: -6px;
      background: url('../../../../assets/angle.svg') #e9f0f4;
      z-index: 1;
    }
  }


  .inner-list_vertical > .project-node:last-of-type > .project-item:last-of-type {
    &::before {
      width: 15px;
    }
  }

  .inner-list_horizontal > .project-node:last-of-type > .project-item:last-of-type {
    &::before {
      width: 1px;
    }
  }


  .inner-list_vertical > .project-node >  .project-item {
    &::before {
      width: 20px;
      height: 1px;
      right: 100%;
      left: auto;
      top: calc(50% - 0.5px);
      bottom: auto;
    }
  }


  .inner-list_horizontal > .project-node > .project-item {
    &::before {
      content: '';
      position: absolute;
      width: 1px;
      height: 20px;
      background: $line;
      left: calc(50% - 0.5px);
      top: auto;
      bottom: calc(100% + 1px);
    }
  }


  .project-top {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    min-height: 16px;
  }

  .controls-cont {
    min-width: 56px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    top: -19px;
    z-index: 5;

    button {
      width: 16px;
      height: 16px;
      margin:  0 2px;
      background: $lightBlue;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center
    }

    svg {
      max-width: 12px;

      &:hover {
        path{
          fill: white!important;
        }
      }
    }

    &:hover {
      svg path{
        fill: white!important;
      }
    }

    .plus-icon {
      border-radius: 50%;
      background: $grey;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .add-btn {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid $lightBlue;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 8;
    display: flex;

    &:hover {
      border-color: white;
      background: $lightBlue;
    }
  }

  .add-btn-right {
    right: -8px;
    top: calc(50% - 8px);

    .btn-hint {
      left: calc(50% - 170/2*1px) !important
    }

  }

  .add-btn-bottom {
    bottom: -8px;
    right: calc(50% - 8px);
  }

  .popup-del {
    position: fixed;
    background: white;
  }

  .hiddenClass {
    visibility: hidden!important;
  }
  .project-node {
    position: relative;
  }
  .before-node {
    position: absolute;
    top: -11px;
    left: 0;
    width: 100%;
    height: 11px;
    z-index: 2;
    text-align: right;
    font-size: 10px;
  }
  .after-node {
    position: absolute;
    bottom: -11px;
    left: 0;
    width: 100%;
    height: 11px;
    z-index: 2;
    text-align: right;
    font-size: 10px;
  }
  .before-node-first-level {
    top: 0;
    left: -20px;
    width: 20px;
    height: 100%;
  }
  .after-node-first-level {
    top: 0;
    left: auto;
    right: -20px;
    width: 20px;
    height: 100%;
  }
  .project-item-dop {
    background: #e9f0f4;
    border: 2px dashed rgba(0, 82, 127, 0.2);
  }
</style>

<style lang="scss">
  .colorTest {
    //background: red;
  }
</style>
